// Shared by the (small, always-loaded) launcher and the (lazy) terminal itself,
// so opening it never requires importing the terminal's code up front.
export const OPEN_TERMINAL_EVENT = 'open-terminal';

// True when a keypress should open the terminal: the backtick key, with no
// modifiers, while the visitor is not typing in a field.
export function isTerminalShortcut(event) {
    const el = typeof document !== 'undefined' ? document.activeElement : null;
    const typing = el && (/^(INPUT|TEXTAREA|SELECT)$/.test(el.tagName) || el.isContentEditable);
    return event.key === '`' && !typing && !event.metaKey && !event.ctrlKey && !event.altKey;
}
